module.exports = __webpack_public_path__ + "img/awards_decoration1.a773e091.png";